const config = {
    development: {
        API_BASE_URL: '/main/api'
    },
    production: {
        API_BASE_URL: '/main/api'
    }
};

export default config[process.env.NODE_ENV || 'development'];